import { HSUserSchema } from 'generated/types/HelloRequest';
import React from 'react';


/**
 * HSUser represents how the user object is being used today.
 *
 * @param data
 */
export const verifySchemaCompaibilityA = (data: HSUserSchema): HSUser => data;
export const verifySchemaCompaibilityB = (user: HSUser): HSUserSchema => user;

/**
 * This is the user that gets passed down through prepareSPA
 */

export type HSUser = {
  isFree: boolean;
  emailAddress: string;
  canAccessBulkSendUI: boolean;
  hasTeam: boolean;
  guid: string;
  // I'm not completely sure if this is an exhaustive list of the possible
  // plans. This type is really about documenting how `user` is already used.
  //
  // https://github.com/HelloFax/HelloFax/blob/ac8eb4a7115c160c3f895215ec300f2a7cef65f4/lib/model/doctrine/BillingPlanQuota.class.php#L28-L40
  plan:
    | 'API Basic'
    | 'Grandfathered'
    | '(Grandfathered 2016)'
    | 'Free'
    | 'Test Mode'
    | 'Free'
    | 'Free Premium'
    | 'Essentials'
    | 'Business'
    | 'Business 10'
    | 'Web 300k'
    | 'Standard'
    | 'Premium'
    | 'Enterprise'
    | 'Enterprise+'


  settings: {
    firstName: string,
    lastName: string,
  }
  id: number,
  numApiDocsLeft: number,
  numDocsLeft: number,
  name: string,
  numTemplatesLeft: number,
  numFaxPagesLeft: number,
  canAccessAdminConsole: boolean,
  canAccessTemplateConverter: boolean,
  referUrl: string


  noTimeout: boolean;
  isFromSelfServeApi: boolean;
  primarySignatureGuid?: string;
  showApiCredits: boolean;
  canCreateEditTemplate: boolean;
  hasLegacyApiKeys: boolean;
};
const hsUserContext = React.createContext<HSUser | null>(null);
export const HSUserProvider = hsUserContext.Provider;
export function useHSUser(): HSUser {
  const user = React.useContext(hsUserContext);
  if (!user) {
    throw new Error('useHsUser must be rendered in an HSUserProvider');
  }

  return user;
}
